import { AnalyseConstants } from '../../../_constants';

const initialState = { assessorGroupsLoading: true, data: '', error: false };

export function assessorGroupsReducer(state = initialState, action) {
    
    switch (action.type) {
        case AnalyseConstants.REQUEST_ASSESSOR_GROUPS:
            return {
                assessorGroupsLoading: true,
                data: '',
                error: false
            };
        case AnalyseConstants.RECEIVE_ASSESSOR_GROUPS:
            // action.assessorGroups.data.assessor_groups_for_team = action.assessorGroups.data.organisation_assessor_groups.map(val => ({assessor_name: val.assessor_group__assessor_name, id: val.assessor_group_id, actualId: val.id}))
            return {
                assessorGroupsLoading: false,
                data: action.assessorGroups,
                error: false
            };
        case AnalyseConstants.ASSESSOR_GROUPS_ERROR:
            return {
                assessorGroupsLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyse/AssessorList/getAssessorList.reducer.js